import React, { useState } from 'react';
import { Gift } from 'lucide-react';
import FriendInviteModal from './FriendInviteModal';
import useInviteRewardToasts from './useInviteRewardToasts';

const BUTTON =
  'flex items-center gap-1.5 rounded-full px-3.5 py-1.5 text-xs font-semibold text-primary ' +
  'border border-primary/20 bg-primary/5 transition-colors hover:bg-primary/10';

/**
 * ホームに置く友だち招待の導線。
 *
 * 組織内招待（InviteMemberButton → /organization）とは別物。こちらは権限にも
 * プラン・課金状態にも左右されず、誰でも使える（仕様2）。
 */
const FriendInviteEntry: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  // 付与は被招待者の操作で非同期に起きるため、招待者がこの画面を開いた時に
  // まとめて知らせる（仕様 3-4: 無言で残高だけ変わる状態にしない）。
  useInviteRewardToasts();

  return (
    <>
      <button type="button" className={BUTTON} onClick={() => setIsOpen(true)}>
        <Gift className="h-3.5 w-3.5" />
        友だちを招待
      </button>
      <FriendInviteModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
};

export default FriendInviteEntry;
